import { CourseMeta, OutcomeContent } from 'types/data'

import { OutcomeTile } from './OutcomeTile'

interface OutcomeContentListProps {
  content: OutcomeContent[]
  courseMeta: Record<string, CourseMeta>
  isPrioritized?: boolean
}

export const OutcomeContentList = ({
  content,
  courseMeta,
  isPrioritized = false,
}: OutcomeContentListProps) => (
  <div className='container'>
    <div className='row'>
      {content.map((contentItem) => (
        <div
          className='col-12 col-md-6 col-lg-4 mc-mb-8'
          key={contentItem.slug}
        >
          <OutcomeTile
            courseMeta={courseMeta[contentItem.courseSlug]}
            content={contentItem}
            isPrioritized={isPrioritized}
          />
        </div>
      ))}
    </div>
  </div>
)
